import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';

/**
 *  IntersectionObserver-based component that delays onChange for use in tagging impressions
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function DelayedImpressionObserver(_ref) {
  let {
    children,
    delay = 1000,
    onChange,
    ...rest
  } = _ref;
  const impressed = useRef(false);
  const handleInView = useCallback(inView => {
    if (inView && !impressed.current) {
      setTimeout(() => {
        onChange();
      }, delay);
      impressed.current = true;
    }
  }, [impressed, onChange, delay]);
  return /*#__PURE__*/_jsx(InView, {
    as: "div",
    "data-cmp": "delayedImpressionWaypoint",
    onChange: inView => handleInView(inView),
    ...rest,
    children: children
  });
}
export default DelayedImpressionObserver;